<section class="container" [ngClass]="{'type-b scroll-gray': templateSuffix !== ''}">

  <div class="subcontainer">
    <div class="header">

      <h2>
        <strong> {{ title }} </strong>
      </h2>

      <div class="btn-cancel" mat-button mat-dialog-close>
        <mat-icon> close </mat-icon>
      </div>
    </div>

    <div id="mifiel-widget">
    </div>

  </div>

</section>
